import React from 'react';
import { Column } from 'react-table';
import classNames from 'classnames';

import style from './Employees.module.scss';

import FormattedCurrency from 'components/FormattedCurrency/FormattedCurrency';
import { withArrow } from 'components/Table/helpers';

export const hostessConfig: Column[] = [
  {
    Header: withArrow('title.nutzerNummer'),
    accessor: 'id',
    resizable: false,
    minWidth: 200,
  },
  {
    Header: withArrow('title.nickname'),
    accessor: 'nickname',
    resizable: false,
    minWidth: 280,
  },
];

export const accountantConfig: Column[] = [
  {
    Header: withArrow('title.nutzerNummer'),
    accessor: 'id',
    minWidth: 100,
    Cell: row => <span className={style.cell__text}>{row.value}</span>,
  },
  {
    Header: withArrow('title.nickname'),
    accessor: 'nickname',
    minWidth: 100,
    Cell: row => <span className={style.cell__text}>{row.value}</span>,
  },
  {
    Header: withArrow('title.userGroups'),
    accessor: 'userGroups',
    minWidth: 100,
    Cell: row =>
      row.value?.map(group => (
        <div key={group.id} className={style.cell__text}>
          {group.name}
        </div>
      )),
  },
  {
    Header: withArrow('title.balance'),
    accessor: 'balance',
    resizable: false,
    width: 120,
    className: 'balance',
    Cell: row => <FormattedCurrency value={row.value} />,
  },
  {
    Header: withArrow('title.refund', { className: style.refunded__header }),
    accessor: 'refunded',
    resizable: false,
    width: 150,
    className: 'tags',
    Cell: row => (
      <span
        className={classNames(style.tag, {
          [style.tag__exist]: row.value,
        })}
      />
    ),
  },
];
